/**
 * Language content for again action
 */

export const againLanguage = {
  actionId: 'if.action.again',

  patterns: [
    'again',
    'g'
  ],

  messages: {
    // Error messages
    'nothing_to_repeat': "There is nothing to repeat."
  },

  help: {
    description: 'Repeat the last command.',
    examples: 'again, g',
    summary: 'AGAIN (G) - Repeat the last command. Example: G'
  }
};
